import { fetchJson$ } from '@atlassian/jira-fetch';

const createProjectHasSubtaskValidatorsUrl = (baseUrl: string, projectKey: string) =>
	`${baseUrl}/rest/internal/2/project/${projectKey}/hasValidatorsOnSubtasks`;

export const fetchProjectHasSubtaskValidators = (baseUrl: string, projectKey: string) =>
	fetchJson$(createProjectHasSubtaskValidatorsUrl(baseUrl, projectKey));
